/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { BulkEditResultResponseResultsInnerError } from './BulkEditResultResponseResultsInnerError';
import {
    BulkEditResultResponseResultsInnerErrorFromJSON,
    BulkEditResultResponseResultsInnerErrorFromJSONTyped,
    BulkEditResultResponseResultsInnerErrorToJSON,
} from './BulkEditResultResponseResultsInnerError';
import type { BulkEditResultResponseResultsInnerRejectedInner } from './BulkEditResultResponseResultsInnerRejectedInner';
import {
    BulkEditResultResponseResultsInnerRejectedInnerFromJSON,
    BulkEditResultResponseResultsInnerRejectedInnerFromJSONTyped,
    BulkEditResultResponseResultsInnerRejectedInnerToJSON,
} from './BulkEditResultResponseResultsInnerRejectedInner';

/**
 * 
 * @export
 * @interface BulkEditResultResponseResultsInner
 */
export interface BulkEditResultResponseResultsInner {
    /**
     * correct | contributions | change_artists | release_link | validation
     * @type {string}
     * @memberof BulkEditResultResponseResultsInner
     */
    action: string;
    /**
     * 
     * @type {string}
     * @memberof BulkEditResultResponseResultsInner
     */
    status: BulkEditResultResponseResultsInnerStatusEnum;
    /**
     * 
     * @type {BulkEditResultResponseResultsInnerError}
     * @memberof BulkEditResultResponseResultsInner
     */
    error?: BulkEditResultResponseResultsInnerError | null;
    /**
     * 
     * @type {Array<BulkEditResultResponseResultsInnerRejectedInner>}
     * @memberof BulkEditResultResponseResultsInner
     */
    rejected?: Array<BulkEditResultResponseResultsInnerRejectedInner>;
}


/**
 * @export
 */
export const BulkEditResultResponseResultsInnerStatusEnum = {
    Succeeded: 'succeeded',
    Failed: 'failed',
    NotImplemented: 'not_implemented'
} as const;
export type BulkEditResultResponseResultsInnerStatusEnum = typeof BulkEditResultResponseResultsInnerStatusEnum[keyof typeof BulkEditResultResponseResultsInnerStatusEnum];


/**
 * Check if a given object implements the BulkEditResultResponseResultsInner interface.
 */
export function instanceOfBulkEditResultResponseResultsInner(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "action" in value;
    isInstance = isInstance && "status" in value;

    return isInstance;
}

export function BulkEditResultResponseResultsInnerFromJSON(json: any): BulkEditResultResponseResultsInner {
    return BulkEditResultResponseResultsInnerFromJSONTyped(json, false);
}

export function BulkEditResultResponseResultsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): BulkEditResultResponseResultsInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'action': json['action'],
        'status': json['status'],
        'error': !exists(json, 'error') ? undefined : BulkEditResultResponseResultsInnerErrorFromJSON(json['error']),
        'rejected': !exists(json, 'rejected') ? undefined : ((json['rejected'] as Array<any>).map(BulkEditResultResponseResultsInnerRejectedInnerFromJSON)),
    };
}

export function BulkEditResultResponseResultsInnerToJSON(value?: BulkEditResultResponseResultsInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'action': value.action,
        'status': value.status,
        'error': BulkEditResultResponseResultsInnerErrorToJSON(value.error),
        'rejected': value.rejected === undefined ? undefined : ((value.rejected as Array<any>).map(BulkEditResultResponseResultsInnerRejectedInnerToJSON)),
    };
}

